import { ILocaleDef, TLocale } from "./locales.models";

/** Ukrainian first: it is the default and the one served without a URL prefix. */
export const LOCALES: TLocale[] = ["uk", "en"];

export const DEFAULT_LOCALE: TLocale = "uk";

export const LOCALE_DEFS: Record<TLocale, ILocaleDef> = {
  uk: {
    lang: "uk",
    ogLocale: "uk_UA",
    intlLocale: "uk-UA",
    nativeName: "Українська",
    shortName: "UA",
  },
  en: {
    lang: "en",
    ogLocale: "en_US",
    intlLocale: "en-GB",
    nativeName: "English",
    shortName: "EN",
  },
};

/** Namespaces are split so each app bundles only the copy it renders. */
export const COMMON_NAMESPACE = "common";
export const LANDING_NAMESPACE = "landing";
export const APP_NAMESPACE = "app";
